




















import { mapActions, mapGetters } from 'vuex'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { loadAllAnalyticsServices } from '@/analytics/analytics-services'
import NavBar from './nav-bar/NavBar.vue'
import Banner from './banner/Banner.vue'
import { NAV_LINKS } from '../constants'

export default {
  components: {
    NavBar,
    LoadingSpinner,
    Banner
  },
  data() {
    return {
      isLoading: true,
      transitionName: 'slide-right',
      isOldOrcas: true,
      isBannerVisible: false
    }
  },
  computed: {
    ...mapGetters([
      'userHasAcceptedAnalyticsCookies',
      'isBannerOpen',
      'canUseOrcasTmsPortal'
    ])
  },
  watch: {
    $route(to) {
      parent.postMessage(JSON.stringify(to.query), '*')
    }
  },
  async created() {
    if (this.userHasAcceptedAnalyticsCookies) loadAllAnalyticsServices()

    await Promise.all([
      this.fetchVehicleTypes(),
      this.fetchCarrierPartnerManager(),
      this.fetchPaymentPeriodDetails()
    ])
    this.isLoading = false

    this.$router.beforeEach((to, from, next) => {
      const toDepth = this.getIndexOfPath(to.path)
      const fromDepth = this.getIndexOfPath(from.path)
      this.transitionName = toDepth < fromDepth ? 'slide-left' : 'slide-right'
      next()
    })
  },
  mounted() {
    this.isOldOrcas = !this.$route.query.iframe
    this.isBannerVisible = this.manageVasBanner()
  },
  methods: {
    ...mapActions([
      'fetchVehicleTypes',
      'fetchCarrierPartnerManager',
      'fetchPaymentPeriodDetails'
    ]),
    getActivePathClass(to) {
      return this.$route.path === to && 'router-link-exact-active'
    },
    getIndexOfPath(to) {
      return Object.values(NAV_LINKS).findIndex(path => path === to)
    },
    manageVasBanner() {
      return !this.isOldOrcas ? true : !this.canUseOrcasTmsPortal
    }
  }
}
